import React from 'react';

const TorExitNodeAdapterSummary = () => <i>No configuration necessary</i>;

export default TorExitNodeAdapterSummary;



// WEBPACK FOOTER //
// ./src/web/components/adapters/torexitnode/TorExitNodeAdapterSummary.jsx